import "./style.scss"
import ESGChatMain from "../../esg-chat/esg-chat";

const ChunkEvaluation = () => {
    return (
        <div className="chunk-evaluation-main">
                    <ESGChatMain
                    searchType="Company"
                    showDisclosuresSection
                    chunkEvaluation={true}
                    />
                </div>
    )
}

export default ChunkEvaluation;